import { type CaseStatusKeys } from "~/features/orders/orderDetails/components/ServiceCases/types";

export const getTagVariant = (status: CaseStatusKeys) => {
  switch (status) {
    case "NEW":
      return undefined;
    case "IN_PROGRESS":
      return "warn";
    case "CLOSED":
      return "success";
    default:
      return undefined;
  }
};
